
<div style="display: flex;">
  <div  style="width: 46%; margin: 2%;">
    <h2 class="title" >LOKALIZACJA I DODATKOWE INFORMACJE</h2>
    <div class="map-container"  *ngIf="this.lat">
      <agm-map [latitude]="lat" [longitude]="lng" (mapReady)="mapReady($event)">
        <agm-marker
          [latitude]="this.lat"
          [longitude]="this.lng"></agm-marker>
      </agm-map>
    </div>
    <h3 class="table" style="padding: 12px 30px">Dodatkowe informacje: {{extra || "brak"}}</h3>
    <h3 class="table" style="padding: 12px 30px" *ngIf="!this.lat">Lokalizacja niedostępna dla tego nagrobka</h3>

  </div>
  
  <div  style="width: 46%; margin: 2%;">
    <h2 class="title" >LISTA ZMARŁYCH</h2>
  <table
    mat-table
    [dataSource]="this.peopleDataSource"
    class="mat-elevation-z8 list "
  >
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef>Nazwisko</th>
      <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
    </ng-container>
  
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef>Imię</th>
      <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
    </ng-container>
  
    <ng-container matColumnDef="birthDate">
      <th mat-header-cell *matHeaderCellDef>Data urodzenia</th>
      <td mat-cell *matCellDef="let element">{{ element.birthDate }}</td>
    </ng-container>
  
    <ng-container matColumnDef="dateOfDeath">
      <th mat-header-cell *matHeaderCellDef>Data śmierci</th>
      <td mat-cell *matCellDef="let element">{{ element.dateOfDeath }}</td>
    </ng-container>
  
    <ng-container matColumnDef="extraInfo">
      <th mat-header-cell *matHeaderCellDef>Dodatkowe informacje</th>
      <td mat-cell *matCellDef="let element">{{ element.extraInfo }}</td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  </div>

</div>



<h2 class="title">LISTA ZDJĘĆ</h2>
  <mat-grid-list cols="3"  rowHeight="500px" gutterSize="40px" style="margin: 40px;">
    <div *ngFor="let image of images">
      <mat-grid-tile style="background-color: #dbd9b8">
        <img
          class="image"
          src="{{ image }}"
          onerror="this.onerror=null;this.src='https://kombit.net.pl/wp-content/themes/consultix/images/no-image-found-360x250.png';"
        />
      </mat-grid-tile>
    </div>
  </mat-grid-list>
